import { render, staticRenderFns } from "./Aswitch.vue?vue&type=template&id=7337e476&"
import script from "./Aswitch.vue?vue&type=script&lang=js&"
export * from "./Aswitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports